import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  TopUpRotation,
} from "@/Enums";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  useWebchargeSettings,
} from "@/composables/useWebchargeSettings";

import {
  useCardLimites,
} from "@/composables/useCardLimites";

import {
  useGratificationSettings,
} from "@/composables/useGratificationSettings";

import DateInput from "@/components/base/DateInput.vue";

import {
  getMinDateRestriction,
} from "@/scripts/Common/HelperFunctions";

import {
  hasValidAmount,
  hasValidRotationEnd,
  UpdateOrCreateConfiguredWebcharge
} from "@/components/issuers/scripts/configuredWebcharges";

import {
  useWebchargeRotations,
} from "@/components/issuers/composables/useWebchargeRotations";


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkCreateIssuerWebchargesDialog',
  props: {
  selectedIds: {
    required: true,
    type: Array as PropType<number[]>,
  },
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm',
  'onError'
],
  setup(__props, { emit: emits }) {

const props = __props;

const amount = ref<number>(0);
const rotation = ref<TopUpRotation>(TopUpRotation.None);
const nextChargingDate = ref<string>();
const rotationEnd = ref<string>();

const webchargesToCreate = ref<UpdateOrCreateConfiguredWebcharge[]>([]);

const isValid = ref(true);
const isDialogVisible = ref<boolean>(false);
const bulkCreateWebchargesForm = ref();



const {
  t,
} = useI18n();

const {
  error: webchargeSettingsError,
  getEnabledDates
} = useWebchargeSettings();

const {
  error: cardLimiteError,
  cardLimite
} = useCardLimites();

const {
  error: gratificationError,
  gratificationSettings
} = useGratificationSettings();

const {
  rotations
} = useWebchargeRotations();



const onHandleDialogCancel = () => {
  emits('onDialogCancel');
}

const onHandleDialogError = (error: any) => {
  emits('onError', {error});
}

const onHandleDialogConfirm = () => {
  webchargesToCreate.value = props.selectedIds.map((cardId: number) => ({
    id: 0,
    cardId: cardId,
    amount: unref(amount),
    rotation: unref(rotation),
    nextChargingDate: unref(isTopRotationNoneSelected) ? undefined : unref(nextChargingDate),
    rotationEnd: unref(isTopRotationNoneSelected) ? undefined : unref(rotationEnd)
  }));

  emits('onDialogConfirm', webchargesToCreate);
}

const isTopRotationNoneSelected = computed(() =>
  rotation.value === TopUpRotation.None
);

const getCurrentAllowedAmount = () => {
  switch (rotation.value) {
    case TopUpRotation.Monthly: {
      return cardLimite.value.maxMonthlyTopUpAmount;
    }
    case TopUpRotation.Gratification: {
      return gratificationSettings.value.maximumAmountPerCharge;
    }
    default: {
      return cardLimite.value.maxCardLimit > cardLimite.value.topUpLimitPerMonth
        ? cardLimite.value.maxCardLimit
        : cardLimite.value.topUpLimitPerMonth;
    }
  }
}

const validateForm = () => {
  (bulkCreateWebchargesForm.value as any).validate();
}

onMounted( () => {
  isDialogVisible.value = true;
});

onUnmounted(() => {
  isDialogVisible.value = false;
})

watch(webchargeSettingsError, () => {
  onHandleDialogError(webchargeSettingsError)
});

watch(gratificationError, () => {
  onHandleDialogError(gratificationError)
});

watch(cardLimiteError, () => {
  onHandleDialogError(cardLimiteError)
});

return { __sfc: true,amount, rotation, nextChargingDate, rotationEnd, webchargesToCreate, isValid, isDialogVisible, bulkCreateWebchargesForm, props, t, webchargeSettingsError, getEnabledDates, cardLimiteError, cardLimite, gratificationError, gratificationSettings, rotations, emits, onHandleDialogCancel, onHandleDialogError, onHandleDialogConfirm, isTopRotationNoneSelected, getCurrentAllowedAmount, validateForm, DateInput, getMinDateRestriction, hasValidAmount, hasValidRotationEnd }
}

})